import React from 'react';
import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Image from '../elements/Image';

const propTypes = {
  ...SectionTilesProps.types
}

const defaultProps = {
  ...SectionTilesProps.defaults
}

class FeaturesTiles extends React.Component {

  render() {

    const {
      className,
      topOuterDivider,
      bottomOuterDivider,      
      topDivider,
      bottomDivider,
      hasBgColor,
      invertColor,
      pushLeft,
      ...props
    } = this.props;

    const outerClasses = classNames(
      'features-tiles section',
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color',
      className
    );

    const innerClasses = classNames(
      'features-tiles-inner section-inner',
      topDivider && 'has-top-divider',
      bottomDivider && 'has-bottom-divider'
    );

    const tilesClasses = classNames(
      'tiles-wrap',
      pushLeft && 'push-left'
    );

    const sectionHeader = {
      title: '',
      paragraph: ''
    };

    return (
      <section
        {...props}
        className={outerClasses}
      >
        <div className="container">
          <div className={innerClasses}>
            <SectionHeader data={sectionHeader} className="center-content" />
            <div className={tilesClasses}>

              <div className="tiles-item reveal-from-bottom" data-reveal-container=".tiles-wrap">
                <div className="tiles-item-inner">
                  <div className="features-tiles-item-header">
                    <div className="features-tiles-item-image mb-16"><a target="_blank" rel="noreferrer"  href="https://icons8.com/icon/111460/graduation-cap">
                      <Image
                        src={require('../../assets/images/icons8-graduation-cap-64.png')}
                        alt="Features tile icon 01"
                        width={64}
                        height={64} />
                      </a>
                    </div>
                  </div>
                  <div className="features-tiles-item-content">
                    <h4 className="mt-0 mb-8">
                      LLM Systems - RAG and Chatbots
                    </h4>
                    <p className="m-0 text-sm">
                     Design and deployment of RAG-based LLM systems for enterprise use cases — enabling accurate, grounded, and source-traceable responses across complex knowledge domains.
                    </p>
                  </div>
                </div>
              </div>

              <div className="tiles-item reveal-from-bottom" data-reveal-container=".tiles-wrap" data-reveal-delay="100">
                <div className="tiles-item-inner">
                  <div className="features-tiles-item-header">
                    <div className="features-tiles-item-image mb-16">
                    <a target="_blank" rel="noreferrer"  href="https://icons8.com/icon/NXD738PNF5MC/contribution">
                      <Image
                        src={require('../../assets/images/icons8-contribution-64.png')}
                        alt="Features tile icon 02"
                        width={64}
                        height={64} />
                        </a>
                    </div>
                  </div>
                  <div className="features-tiles-item-content">
                    <h4 className="mt-0 mb-8">
                      Agentic AI Workflows
                    </h4>
                    <p className="m-0 text-sm">
                      Build agentic AI systems that orchestrate multi-step reasoning across tools, APIs, and data sources — automating complex business processes beyond single-turn interactions.
                    </p>
                  </div>
                </div>
              </div>

              <div className="tiles-item reveal-from-bottom" data-reveal-container=".tiles-wrap" data-reveal-delay="200">
                <div className="tiles-item-inner">
                  <div className="features-tiles-item-header">
                    <div className="features-tiles-item-image mb-16">
                    <a target="_blank" rel="noreferrer"  href="https://icons8.com/icon/Cc5U1vG2huUW/weight-care">
                      <Image
                        src={require('../../assets/images/icons8-integrity-50.png')}
                        alt="Features tile icon 03"
                        width={64}
                        height={64} />
                        </a>
                    </div>
                  </div>
                  <div className="features-tiles-item-content">
                    <h4 className="mt-0 mb-8">
                      AI-Driven Automation
                    </h4>
                    <p className="m-0 text-sm">
                    Develop AI-powered automation workflows integrating LLMs, APIs, and data pipelines — reducing manual effort and enabling scalable, repeatable operations.
                    </p>
                  </div>
                </div>
              </div>

              <div className="tiles-item reveal-from-bottom" data-reveal-container=".tiles-wrap" data-reveal-delay="300">
                <div className="tiles-item-inner">
                  <div className="features-tiles-item-header">
                    <div className="features-tiles-item-image mb-16">
                    <a target="_blank" rel="noreferrer"  href="https://icons8.com/icon/42816/idea">
                      <Image
                        src={require('../../assets/images/icons8-idea-64.png')}
                        alt="Features tile icon 04"
                        width={64}
                        height={64} />
                        </a>
                    </div>
                  </div>
                  <div className="features-tiles-item-content">
                    <h4 className="mt-0 mb-8">
                     Production MLOps and Cloud Deployment
                    </h4>
                    <p className="m-0 text-sm">
                    Deploy and operate production-grade AI systems using Azure, Docker, and Kubernetes — with CI/CD pipelines, monitoring, and scalable infrastructure.
                    </p>
                  </div>
                </div>
              </div>

              <div className="tiles-item reveal-from-bottom" data-reveal-container=".tiles-wrap" data-reveal-delay="400">
                <div className="tiles-item-inner">
                  <div className="features-tiles-item-header">
                    <div className="features-tiles-item-image mb-16">
                    <a target="_blank" rel="noreferrer"  href="https://icons8.com/icon/61864/artificial-intelligence">
                      <Image
                        src={require('../../assets/images/icons8-ai-64.png')}
                        alt="Features tile icon 05"
                        width={64}
                        height={64} />
                        </a>
                    </div>
                  </div>
                  <div className="features-tiles-item-content">
                    <h4 className="mt-0 mb-8">
                      Enterprise AI - Secure and Scalable
                    </h4>
                    <p className="m-0 text-sm">
                    Deliver AI systems in regulated environments with strict data protection requirements — ensuring compliance, security, and reliability by design.
                    </p>
                  </div>
                </div>
              </div>

              <div className="tiles-item reveal-from-bottom" data-reveal-container=".tiles-wrap" data-reveal-delay="500">
                <div className="tiles-item-inner">
                  <div className="features-tiles-item-header">
                    <div className="features-tiles-item-image mb-16">
                    <a target="_blank" rel="noreferrer" href="https://icons8.com/icon/gR7LJ77L9EAn/flexibility">
                      <Image
                        src={require('../../assets/images/icons8-flexibility-64.png')}
                        alt="Features tile icon 06"
                        width={64}
                        height={64} /></a>
                    </div>
                  </div>
                  <div className="features-tiles-item-content">
                    <h4 className="mt-0 mb-8">
                      End-to-End AI Systems
                    </h4>
                    <p className="m-0 text-sm">
                    Design and deliver end-to-end AI solutions — from architecture to deployment — integrated into real business workflows and enterprise infrastructure.
                    </p>
                  </div>
                </div>
              </div>              

            </div>
          </div>
        </div>
      </section>
    );
  }
}

FeaturesTiles.propTypes = propTypes;
FeaturesTiles.defaultProps = defaultProps;

export default FeaturesTiles;